function BachelorInAiComponents() {
  return (
    <div>
      <h1>bachelor in ai components</h1>
    </div>
  );
}

export default BachelorInAiComponents;
